import {
  isArray,
  isBoolean,
  isDate,
  isEmpty,
  isNil,
  isNumber,
  isObject,
  isString,
  some,
} from "lodash";

export const isPresent = (value: unknown) => {
  if (isNil(value)) return false;
  if (isNumber(value) || isBoolean(value) || isDate(value)) return true;
  if (isString(value)) return !isEmpty(value);
  if (isArray(value) || isObject(value)) return some(value, isPresent);
  return false;
};
